import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  IconButton,
  Stack,
  Button,
  Divider,
  Typography,
  TextField,
} from '@mui/material';
import Iconify from '../common/iconify.component';
import Scrollbar from '../common/scrollbar.component';
import Platforms from '../form-elements/platforms.component';
import BRD from '../form-elements/brd.component';
import Datepicker from '../form-elements/datepicker.component';
import Channels from '../form-elements/channels.component';
import BRDSDKVERSION from '../form-elements/brd-sdk-version.component';

const FilterUsers = ({ values, onCancel, onSuccess, onClear }) => {
  const [filters, setFilters] = useState(values);

  const handleApplyFilters = () => {
    setTimeout(() => {
      onSuccess(filters);
    }, 250);
  };

  return (
    <>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ px: 1, py: 2 }}
      >
        <Typography variant="subtitle1" sx={{ ml: 1 }}>
          Filters
        </Typography>
        <IconButton onClick={onCancel}>
          <Iconify icon="eva:close-fill" />
        </IconButton>
      </Stack>

      <Divider />

      <Scrollbar
        sx={{
          height: 1,
          '& .simplebar-content': {
            height: 1,
            display: 'flex',
            flexDirection: 'column',
          },
        }}
      >
        <form id="list-data-filters" onSubmit={(e) => e.preventDefault()}>
          <Stack sx={{ p: 2 }}>
            <TextField
              id="fl_search"
              name="fl_search"
              label="Search"
              variant="filled"
              defaultValue={filters.search}
              onChange={(e) => {
                setFilters({
                  ...filters,
                  search: e.target.value,
                });
              }}
              sx={{ width: '100%' }}
            />

            <Channels
              appId="filterApps"
              appName="filterApps"
              label="Select App"
              defaultValue={filters.filterApp || null}
              onChange={(v) => {
                setFilters({
                  ...filters,
                  filterApp: v,
                });
              }}
              sx={{ width: '100%', mt: 1 }}
            />

            <Platforms
              id="fl_platforms"
              name="fl_platforms"
              label="Platforms"
              defaultValue={filters.platforms}
              multiple
              onChange={(v) => {
                setFilters({
                  ...filters,
                  platforms: v,
                });
              }}
              sx={{ width: '100%', my: 1 }}
            />

            <BRD
              id="fl_brd"
              name="fl_brd"
              label="BRD"
              defaultValue={filters.brd !== null ? filters.brd : null}
              onChange={(v) => {
                setFilters({
                  ...filters,
                  brd: v,
                });
              }}
              validOptions={[0, 1]}
            />
            <BRDSDKVERSION
              id="fl_brd_sdk_version"
              name="fl_brd_sdk_version"
              label="BRD SDK Version"
              defaultValue={
                filters.brdsdkversion !== null ? filters.brdsdkversion : null
              }
              onChange={(v) => {
                setFilters({
                  ...filters,
                  brdsdkversion: v,
                });
              }}
              validOptions={[0, 1]}
            />

            <Datepicker
              id="fl_start_date"
              name="fl_start_date"
              label="From Date"
              defaultValue={filters.startDate}
              clearable
              onChange={(v) => {
                setFilters({
                  ...filters,
                  startDate: v,
                });
              }}
              sx={{ width: '100%' }}
            />

            <Datepicker
              id="fl_end_date"
              name="fl_end_date"
              label="To Date"
              defaultValue={filters.endDate}
              clearable
              onChange={(v) => {
                setFilters({
                  ...filters,
                  endDate: v,
                });
              }}
              sx={{ width: '100%' }}
            />
            <Datepicker
              id="fl_session_start_date"
              name="fl_session_start_date"
              label="Session From Date"
              defaultValue={filters.sessionStartDate}
              clearable
              onChange={(v) => {
                setFilters({
                  ...filters,
                  sessionStartDate: v,
                });
              }}
              sx={{ width: '100%' }}
            />

            <Datepicker
              id="fl_session_end_date"
              name="fl_session_end_date"
              label="Session To Date"
              defaultValue={filters.sessionEndDate}
              clearable
              onChange={(v) => {
                setFilters({
                  ...filters,
                  sessionEndDate: v,
                });
              }}
              sx={{ width: '100%' }}
            />
          </Stack>
        </form>
      </Scrollbar>

      <Divider />

      <Stack spacing={1} sx={{ p: 2 }}>
        <Button
          fullWidth
          form="list-data-filters"
          type="submit"
          color="primary"
          variant="contained"
          onClick={handleApplyFilters}
        >
          Apply Filters
        </Button>
        <Button
          fullWidth
          type="button"
          color="secondary"
          variant="contained"
          startIcon={<Iconify icon="ic:round-clear-all" />}
          onClick={onClear}
        >
          Clear All
        </Button>
      </Stack>
    </>
  );
};

FilterUsers.propTypes = {
  values: PropTypes.shape().isRequired,
  onCancel: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
};

export default FilterUsers;
